import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { Paper, Stack, Typography } from "@mui/material";

export interface Decyzja {
  id: string;
  verdict: string;
  comment: string;
  user_label: string;
  created_at: string;
  step?: string;
}

/** Komentarz zapisany i niepokazany jest tym samym, co komentarz niezapisany. */
export function DecisionHistory({ decyzje }: { decyzje: Decyzja[] }) {
  if (!decyzje.length) return null;

  return (
    <Paper variant="outlined" sx={{ p: 2 }}>
      <Typography variant="subtitle2" gutterBottom>Historia decyzji</Typography>
      <Stack spacing={1.5}>
        {decyzje.map((d) => {
          const odrzucenie = d.verdict === "reject";
          return (
            <Stack key={d.id} direction="row" spacing={1.5} alignItems="flex-start">
              {odrzucenie
                ? <HighlightOffIcon color="error" fontSize="small" sx={{ mt: 0.3 }} />
                : <CheckCircleOutlineIcon color="success" fontSize="small" sx={{ mt: 0.3 }} />}
              <Stack>
                <Typography variant="body2">
                  <strong>{odrzucenie ? "Odrzucone" : "Zatwierdzone"}</strong>
                  {d.step ? ` · ${d.step}` : ""} · {d.user_label} ·{" "}
                  {new Date(d.created_at).toLocaleString("pl-PL")}
                </Typography>
                {d.comment && (
                  <Typography variant="body2" color="text.secondary"
                              sx={{ whiteSpace: "pre-wrap" }}>
                    {d.comment}
                  </Typography>
                )}
              </Stack>
            </Stack>
          );
        })}
      </Stack>
    </Paper>
  );
}
